import Vue from 'vue'
import App from './App.vue'
import router from './router'


Vue.config.productionTip = false

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper, /* { default global options } */)

import axios from './axios/index'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.filter('dateTrans', val => {
	let date = new Date(val * 1000);
	let month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
	let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
	return date.getFullYear() + '-' + month + '-' + day;
})


new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
